import { z } from 'zod';
import { AnswerByCategoryPinLayoutTemplateSchema } from './answer-by-category-pin';
import { BaseStyleSchema } from './base-pin';
import { DragAndDropPinLayoutTemplateSchema } from './drag-and-drop-pin';
import { FillInTheBlanksPinLayoutTemplateSchema } from './fill-in-the-blanks-pin';
import { OpenQuestionPinLayoutTemplateSchema } from './open-question-pin';
import { PollPinLayoutTemplateSchema } from './poll-pin';
import { QuizPinLayoutTemplateSchema } from './quiz-pin';
import { SlidePinLayoutTemplateSchema } from './slide-pin';
import { SortingQuestionPinLayoutTemplateSchema } from './sorting-question-pin';
import { WordCloudPinLayoutTemplateSchema } from './word-cloud-pin';

const StyleSetSchema = z.object({
  id: z.string().min(1),
  name: z.string().min(1),
  colors: z.array(z.string().min(1)),
  styles: z.array(BaseStyleSchema),
});

export type BaseStyle = z.infer<typeof BaseStyleSchema>;
export type StyleSet = z.infer<typeof StyleSetSchema>;

//IF-70: Added Zod Type for TemplateLayouts because node was complaining about the inferred type exceding
// the max length the compiler serializes.
const TemplateLayoutsSchema = z.object({
  slidePinLayouts: z.array(SlidePinLayoutTemplateSchema),
  quizPinLayouts: z.array(QuizPinLayoutTemplateSchema),
  openQuestionLayouts: z.array(OpenQuestionPinLayoutTemplateSchema),
  pollPinLayouts: z.array(PollPinLayoutTemplateSchema),
  wordCloudLayouts: z.array(WordCloudPinLayoutTemplateSchema),
  fillInTheBlanksLayouts: z.array(FillInTheBlanksPinLayoutTemplateSchema),
  answerByCategoryLayouts: z.array(AnswerByCategoryPinLayoutTemplateSchema),
  sortingQuestionLayouts: z.array(SortingQuestionPinLayoutTemplateSchema),
  dragAndDropLayouts: z.array(DragAndDropPinLayoutTemplateSchema),
});

export type TemplateLayouts = z.infer<typeof TemplateLayoutsSchema>;

export const TemplateSchema = z.object({
  id: z.string().min(1),
  name: z.string().min(1),
  styleSets: z.array(StyleSetSchema),
  layouts: TemplateLayoutsSchema,
});

export type Template = z.infer<typeof TemplateSchema>;
